// https://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values
export const TIMEOUT_MAX = 2147483647; // 2^32 (24.85 days)
export const TIMEOUT_HOUR = 3600000;
export const TIMEOUT_DAY = 86400000;

export const AppState = {
  none: "none",
  loading: "loading",
  loaded: "loaded",
  serverDown: "serverDown",
};

export const READER_TOP_PANEL_PORTAL_ID = "reader-top-panel-portal";

export const OptionKeyOptionNotFoundBySearch = "notFoundBySearch";

export const MenuEvents = {
  openInWindow: {
    key: "openInWindow",
    label: "openInWindow",
  },
  openInActiveSplit: {
    key: "openInActiveSplit",
    label: "openInActiveSplit",
  },
  openInTab: {
    key: "openInTab",
    label: "openInTab",
  },
  openInNewSplit: {
    key: "openInSplit",
    label: "openInNewSplit",
  },
  about: {
    key: "about",
    label: "about",
  },
};

export const TOGGLE_IN_LIBRARY_BEHAVIOURS = {
  ASK: 1,
  DO_NOT_ASK: 2,
};

export const TreeMenuMode = {
  CATEGORIES: "categories",
  FOLDERS: "folders",
  TITLES: "titles",
};

export const MENU_STATE_COLLAPSE = "0";

export const TOAST_TYPE = {
  error: "toast-error",
  notify: "toast-notify",
  warning: "toast-warning",
  success: "toast-success",
};

export const SCROLL_DIRECTIONS = {
  UNTOUCHED: "UNTOUCHED",
  UP: "up",
  DOWN: "down",
  LEFT: "left",
  RIGHT: "right",
};

export const ComponentsId = {
  CF_TYPO_ID: "CF_TYPO_ID",
  CF_SEND_ID: "CF_SEND_ID",
};

export const CFStatus = {
  PENDING: "PENDING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
};

export const FontFamily = {
  bebas: "bebas",
  roboto: "roboto"
};
